import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/cert-mobile.png';
import _imports_1 from '@/assets/img/cert.png';
const _withScopeId = n => (_pushScopeId("data-v-628283e3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "dialog-mask"
};
const _hoisted_2 = {
    key: 0,
    src: _imports_0,
    class: "img",
    alt: ""
};
const _hoisted_3 = {
    key: 1,
    src: _imports_1,
    class: "img",
    alt: ""
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "btn_text" }, "立即认证", -1));
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = {
    key: 2,
    class: "text"
};
import { onClickOutside } from "@vueuse/core";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { popupStatus } from "@/service/user";
import { getUserInfo } from "@/utils/auth";
import { isMobileDevice } from "@/utils";
export default /*#__PURE__*/ _defineComponent({
    name: 'certDialog',
    setup(__props) {
        const visible = ref(false);
        const handleClose = () => {
            visible.value = false;
        };
        const target = ref(null);
        onClickOutside(target, () => {
            handleClose();
        });
        const router = useRouter();
        const doNotRemind = ref(false);
        const popupShow = ref(false);
        const todayDate = new Date().toISOString().slice(0, 10);
        const remindKey = `noRemindCertDate_${getUserInfo().user_id}`;
        const getStatus = async () => {
            const { data } = await popupStatus();
            popupShow.value = data.welfare_1_popup;
        };
        // 判断是否今天已勾选“不再提醒”
        const hasNoRemindToday = localStorage.getItem(remindKey) === todayDate;
        // 页面挂载时判断是否需要弹窗
        onMounted(async () => {
            if (localStorage.getItem("loginState") !== "already") {
                return;
            }
            await getStatus();
            if (popupShow.value &&
                !hasNoRemindToday &&
                localStorage.getItem("loginState") === "already") {
                visible.value = true;
            }
        });
        watch(doNotRemind, (val) => {
            if (val) {
                localStorage.setItem(remindKey, todayDate);
            }
            else {
                localStorage.removeItem(remindKey);
            }
        });
        const goPersonal = () => {
            visible.value = false;
            if (isMobileDevice()) {
                router.push("/personal/personalAuth");
            }
            else {
                router.push("/personal/index");
            }
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            return (visible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        ref_key: "target",
                        ref: target,
                        class: _normalizeClass(_unref(isMobileDevice)() ? 'mobile dialog-container' : 'dialog-container')
                    }, [
                        _createElementVNode("div", {
                            class: "close-box display-flex align-items",
                            onClick: handleClose
                        }, [
                            _createVNode(_component_svg_icon, {
                                "icon-class": "close1",
                                class: "close-icon"
                            })
                        ]),
                        (_unref(isMobileDevice)())
                            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                            : (_openBlock(), _createElementBlock("img", _hoisted_3)),
                        _createElementVNode("div", {
                            class: "recharge_btn",
                            onClick: goPersonal
                        }, _hoisted_5),
                        (_unref(isMobileDevice)())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 最终活动解释权归英博数科有限公司所有 "))
                            : _createCommentVNode("", true),
                        _createVNode(_component_el_checkbox, {
                            modelValue: doNotRemind.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((doNotRemind).value = $event)),
                            class: "no_mind",
                            label: "今日不再提醒 ",
                            size: "large"
                        }, null, 8, ["modelValue"])
                    ], 2)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
